import { PartnerFormMenuItems } from 'clickNgo/entities/partner/configs'
import { useGetFormDataField } from 'cng-common/features/form'

import { PartnerEditorFormKeys, PartnerEditorFormSettings } from '../configs'

export const useReadOnlyMenuItem = () => {
  const [isReadOnly] = useGetFormDataField<boolean>(
    PartnerEditorFormKeys.Setting,
    PartnerEditorFormSettings.IsReadOnly
  )
  const [editableMenuItem] = useGetFormDataField<PartnerFormMenuItems[]>(
    PartnerEditorFormKeys.Setting,
    PartnerEditorFormSettings.EditableMenuItems
  )
  const [currentMenuItem] = useGetFormDataField<PartnerFormMenuItems>(
    PartnerEditorFormKeys.Setting,
    PartnerEditorFormSettings.CurrentMenuItem
  )

  const isCurrentMenuItemReadOnly = isReadOnly || !editableMenuItem.includes(currentMenuItem)

  return { isReadOnly, isCurrentMenuItemReadOnly }
}
